// Imports
import { GetWebsiteResponse } from '../../shareables/types/api/main/website/get';
import { GetVisibilityResponse } from '../../shareables/types/api/main/website/homepage/visibility/get';
import { GetMemberResponse } from '../../shareables/types/api/main/website/member/get';
import { GetPageResponse } from '../../shareables/types/api/main/website/page/get';
import { GetPagesResponse } from '../../shareables/types/api/main/website/pages/get';


// Export initial state interface
export interface State {
	website: GetWebsiteResponse | null;
	pages: GetPagesResponse | null;
	pageTypeID: GetPageResponse['pageTypeID'] | null;
	homepageVisibility: GetVisibilityResponse | null;
	member: GetMemberResponse | null;
	memberLoaded: boolean;
	adminView: boolean;
	globalSignIn: boolean;
	globalSignInLoaded: boolean;
	phone: string | null;
}


// Define types/interfaces for actions
export const STORE_WEBSITE = 'STORE_WEBSITE';
export interface StoreWebsiteAction {
	type: typeof STORE_WEBSITE;
	website: GetWebsiteResponse;
}

export const STORE_PAGES = 'STORE_PAGES';
export interface StorePagesAction {
	type: typeof STORE_PAGES;
	pages: GetPagesResponse;
}

export const STORE_HOMEPAGE_VISIBILITY = 'STORE_HOMEPAGE_VISIBILITY';
export interface StoreHomepageVisibilityAction {
	type: typeof STORE_HOMEPAGE_VISIBILITY;
	homepageVisibility: GetVisibilityResponse;
}

export const STORE_MEMBER = 'STORE_MEMBER';
export interface StoreMemberAction {
	type: typeof STORE_MEMBER;
	member: GetMemberResponse;
}

export const SET_MEMBER_LOADED = 'SET_MEMBER_LOADED';
export interface SetMemberLoadedAction {
	type: typeof SET_MEMBER_LOADED;
}

export const SET_ADMIN_VIEW = 'SET_ADMIN_VIEW';

export interface SetAdminViewAction {
	type: typeof SET_ADMIN_VIEW;
	adminView: boolean;
}

export const SET_GLOBAL_SIGN_IN = 'SET_GLOBAL_SIGN_IN';

export interface SetGlobalSignInAction {
	type: typeof SET_GLOBAL_SIGN_IN;
	globalSignIn: boolean;
}

export const SET_GLOBAL_SIGN_IN_LOADED = 'SET_GLOBAL_SIGN_IN_LOADED';

export interface SetGlobalSignInLoadedAction {
	type: typeof SET_GLOBAL_SIGN_IN_LOADED;
}

export const SET_PHONE = 'SET_PHONE';

export interface SetPhoneAction {
	type: typeof SET_PHONE;
	phone: string | null;
}


// Export union type
export type Actions =
	| StoreWebsiteAction
	| StorePagesAction
	| StoreHomepageVisibilityAction
	| StoreMemberAction
	| SetMemberLoadedAction
	| SetAdminViewAction
	| SetGlobalSignInAction
	| SetGlobalSignInLoadedAction
	| SetPhoneAction;
